// Billetterie.jsx — Router fin : choisit Live (event_id présent) ou Demo
import { useSearchParams } from 'react-router-dom';
import BilletterieLive from './BilletterieLive';
import BilletterieDemo from './BilletterieDemo';

export default function Billetterie() {
  const [params] = useSearchParams();
  const eventId = params.get('event_id');
  if (eventId) return <BilletterieLive eventId={eventId} />;
  return <BilletterieDemo />;
}
